import compose from '../utilities/compose';

const popupsState = (storeState) => storeState.popups;

const assignEntity = popupsState => popupsState.assignEntity;

export const assignEntitySavingStatus = storeState => compose(assignEntity, popupsState)(storeState).get('savedSuccessfully');
